import { render, staticRenderFns } from "./ValueCommerceDataRegister.vue?vue&type=template&id=65deca58&scoped=true"
import script from "./ValueCommerceDataRegister.vue?vue&type=script&lang=js"
export * from "./ValueCommerceDataRegister.vue?vue&type=script&lang=js"
import style0 from "./ValueCommerceDataRegister.vue?vue&type=style&index=0&id=65deca58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65deca58",
  null
  
)

export default component.exports